export function graphqlIdToDecimal(graphqlId: string) {
  // decode base64
  // split on ':'
  // remove leading 0X's
  // int = parseInt(, 16)
  const decodedHex = window.atob(graphqlId).split(':')[1];
  return parseInt(decodedHex, 16);
}

export const graphqlIdToDgraphId = (graphqlId: string) => {
  return window.atob(graphqlId).split(':')[1];
};

export const graphqlIdToDBId = (graphqlId: string) => {
  return graphqlIdToDgraphId(graphqlId).slice(2);
};

export function dgraphIdToDecimal(dgraphId: string) {
  return parseInt(dgraphId, 16);
}

export function decimalToDgraphId(decimal: number) {
  return `0x${decimal.toString(16)}`;
}

export function decimalToGraphqlId(decimal: number, typeName: string) {
  /* Converts a decimal dgraph object id to a base64 encoded version of the `type:id` string for use with our API */
  return window.btoa(`${typeName}:${decimalToDgraphId(decimal)}`);
}

export function isGraphqlIdForType(id: string, typeName: string) {
  return window.atob(id).split(':')[0] === typeName;
}

export function ensureIsGraphqlId(id: string, typeName: string) {
  if (!id || isGraphqlIdForType(id, typeName)) {
    return id;
  }
  return decimalToGraphqlId(parseInt(id, 10), typeName);
}
